import React, {FC, PropsWithChildren, useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import Paper from '@mui/material/Paper';
import EnsurePermission from '../../EnsurePermission';
import {Button} from '../../Button';
import {SelectRedirectProps} from './AutocompleteInput';

export type SelectWithNewEntity = {
  redirectOptions: SelectRedirectProps,
  permission?: Nullable<string[]>,
  label?: string,
}

type AutocompleteInputMenuProps = PropsWithChildren<{
  withNewEntity?: SelectWithNewEntity,
  className?: string
}>

const AutocompleteInputMenu:
  FC<AutocompleteInputMenuProps> = ({
    children,
    withNewEntity,
    className
  }) => {
    const history = useHistory();

    const handleRedirect = useCallback(() => {
      const {redirectOptions} = withNewEntity || {};
      const {path, from} = redirectOptions || {};

      if (!path) return;

      if (!from) {
        return history.push(path);
      }

      history.push(path, {from: from});
    }, [withNewEntity]);

    return (
      <Paper className={className}>
        {children}
        {!!withNewEntity && (
          <EnsurePermission elementPermissions={withNewEntity?.permission}>
            <Button
              variant="text"
              fullWidth
              label={withNewEntity?.label || ''}
              onMouseDown={handleRedirect}
              onTouchStart={handleRedirect}
            />
          </EnsurePermission>
        )}
      </Paper>
    );
  };

export default AutocompleteInputMenu;
